import react, { useState } from 'react'

import { Alert, Box } from '@mui/material'
import { useGridApiContext, useGridRootProps } from '@mui/x-data-grid';
import ColorButton from '../Buttons/ColorButton';
import { api } from '../../services/api';
import toast from 'react-hot-toast';

const importdata = async (file, apiRef, rootProps) => {
    const [reqURL,] = rootProps.getURL?.split("?")
    const formdata = new FormData()
    formdata.append('file', file)
    const res = await api.post(`${reqURL}import/`, formdata)
    if (res.status === 200){
        toast.success(`A importação foi iniciada. Aguarde alguns instantes.`)
    } else {
        toast.error(`Ocorreu um erro para importar os dados: ${JSON.stringify(res.data)}`)
    }
    apiRef.close()
}

const Import = () => {

    const apiRef = useGridApiContext()
    const rootProps = useGridRootProps()

    const [file, setFile] = useState()

    return (
        <>
            <Box className='table-column-popover'>
                <Box sx={{ padding: '.5rem', display: 'flex', flexDirection: 'column', gap: '.5rem' }} >
                    <Alert>Só são aceitos arquivos .xls ou .xlsx, a operação ocorrerá em paralelo, erros não serão retornados. Utilize o mesmo formato enviado ao exportar, as colunas 'id' e 'enterprise' são desnecessárias e serão ignoradas.</Alert>
                    <input accept=".xls,.xlsx" type='file' onChange={({target}) => setFile(target.files[0])}></input>
                    <ColorButton
                        reverse={false}

                        disabled={!file}
                        onClick={() => {
                            importdata(file, apiRef, rootProps)
                        }}>Importar</ColorButton>
                </Box>
            </Box>
        </>
    )
}

export default Import